import { render, staticRenderFns } from "./OrderTracking.vue?vue&type=template&id=0c63099b&scoped=true"
import script from "./OrderTracking.vue?vue&type=script&lang=js"
export * from "./OrderTracking.vue?vue&type=script&lang=js"
import style0 from "./OrderTracking.vue?vue&type=style&index=0&id=0c63099b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c63099b",
  null
  
)

export default component.exports